import { useEffect, useRef, useState } from "react";

import { useRouter } from "next/router";
import PropTypes from "prop-types";

import getUserProperties from "@/users/getUserProperties";
import contentPreviewSettings from "@/view/constants/contentPreviewSettings/contentPreviewSettings.constants";

const propTypes = {
  user: PropTypes.object,
  setters: PropTypes.array,
};

const useBannerMode = (user, setters = []) => {
  const router = useRouter();
  const { query } = router;
  const { preview_for: previewFor } = query;

  const bannerRef = useRef(null);
  const [isBannerModeActive, setIsBannerModeActive] = useState(false);

  const isUeaApp =
    previewFor &&
    Object.keys(contentPreviewSettings.supportedValues).includes(previewFor);

  const { isStudent } = getUserProperties(user);
  const canUseBannerMode = !isStudent;

  useEffect(() => {
    if (isUeaApp) {
      setIsBannerModeActive(true);
    } else if (!canUseBannerMode) {
      setIsBannerModeActive(false);
    }

    // Scroll to banner when rendered and focus
    if (isBannerModeActive && bannerRef?.current) {
      bannerRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [isBannerModeActive]);

  const handleToggleBannerMode = () => {
    // Disable states when toggle action called.
    if (setters.length) {
      setters.forEach(function (setter) {
        setter(false);
      });
    }
    setIsBannerModeActive((bannerMode) => !bannerMode);
  };

  const toggleBannerMode = handleToggleBannerMode;

  return {
    canUseBannerMode,
    isBannerModeActive,
    bannerRef,
    toggleBannerMode,
  };
};

useBannerMode.propTypes = propTypes;

export default useBannerMode;
